export default function GermanAustrianAdvantagesSection() {
  const advantages = [
    {
      icon: 'ri-bank-line',
      title: 'Firmengründung & Banking',
      description: 'Direkter Zugang zu etablierten Freezones, Visa-Prozessen und klassischen sowie krypto-nahen Banklösungen',
      image: 'https://public.readdy.ai/ai/img_res/8f8656df9d53b0c60b5d353f50cb7f82.jpg'
    },
    {
      icon: 'ri-stock-line',
      title: 'Investment-Opportunities',
      description: 'Geprüfte Immobilienprojekte, Co-Investment-Strukturen und Zugang zu einem verifizierten Developer-Netzwerk',
      image: 'https://readdy.ai/api/search-image?query=luxury%20dubai%20real%20estate%20investment%20skyline%20with%20modern%20towers%20waterfront%20development%20elegant%20architecture%20golden%20sunset%20professional%20business%20composition&width=800&height=600&seq=dbc-invest&orientation=landscape'
    },
    {
      icon: 'ri-service-line',
      title: 'Experten-Netzwerk',
      description: 'Steuerberater aus Deutschland, Österreich und UAE, Rechtsanwälte für Gesellschaftsrecht sowie erfahrene Strukturberater',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20consultation%20elegant%20office%20meeting%20modern%20corporate%20interior%20sophisticated%20lighting%20executive%20networking%20premium%20atmosphere%20clean%20design&width=800&height=600&seq=dbc-expert&orientation=landscape'
    },
    {
      icon: 'ri-infinity-line',
      title: 'Lebenslange Community',
      description: 'Langfristiger Zugang zu einer exklusiven Unternehmer-Community mit regelmäßigen Events und privatem Austausch',
      image: 'https://readdy.ai/api/search-image?query=exclusive%20luxury%20networking%20event%20dubai%20business%20professionals%20elegant%20venue%20sophisticated%20atmosphere%20premium%20corporate%20gathering%20modern%20interior%20golden%20lighting&width=800&height=600&seq=dbc-community&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-32 bg-white relative">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 bg-yellow-600/10 text-yellow-600 px-4 sm:px-6 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-star-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
            <span className="font-light tracking-wide text-sm sm:text-base">Was Mitglieder erhalten</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl mb-4 sm:mb-6 text-gray-900 px-4">
            Substanz statt Versprechen
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto font-light leading-relaxed px-4">
            Keine Marketing-Floskeln. Keine übertriebenen Erfolgsversprechen. Nur echte Zugänge, geprüfte Kontakte und reale Strukturen.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 max-w-7xl mx-auto">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className="group cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-48 sm:h-56 lg:h-64 mb-4 sm:mb-6 overflow-hidden rounded-lg">
                <img
                  src={advantage.image}
                  alt={advantage.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                
                {/* Icon */}
                <div className="absolute bottom-4 left-4 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-yellow-600 rounded-full">
                  <i className={`${advantage.icon} text-xl sm:text-2xl text-black`}></i>
                </div>
              </div>

              {/* Content */}
              <h3 className="text-lg sm:text-xl font-light text-gray-900 mb-2 sm:mb-3 tracking-wide">
                {advantage.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 font-light leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>

        {/* Process Section */}
        <div className="mt-16 sm:mt-20 lg:mt-32 max-w-5xl mx-auto">
          <div className="bg-neutral-900 p-8 sm:p-10 lg:p-16 relative overflow-hidden">
            {/* Background Accent */}
            <div className="absolute top-0 right-0 w-48 sm:w-64 h-48 sm:h-64 bg-yellow-600/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
            
            <div className="relative z-10">
              <div className="flex items-start gap-3 sm:gap-4 mb-6 sm:mb-8">
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-yellow-600 rounded-full flex-shrink-0 mt-1">
                  <i className="ri-key-2-line text-lg sm:text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-light text-white mb-3 sm:mb-4 tracking-wide">
                    Exklusiver und limitierter Zugang
                  </h3>
                  <p className="text-sm sm:text-base lg:text-lg text-white/70 font-light leading-relaxed">
                    Der Dubai Business Club nimmt nicht jeden auf. Wir prüfen jede Bewerbung individuell und achten auf Substanz, Seriosität und gegenseitigen Mehrwert.
                  </p>
                </div>
              </div>

              {/* Process Steps */}
              <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 mt-8 sm:mt-12">
                <div className="flex flex-col">
                  <div className="text-yellow-600 text-4xl sm:text-5xl font-light mb-2 sm:mb-3">01</div>
                  <h4 className="text-base sm:text-lg text-white font-light mb-2">Bewerbung einreichen</h4>
                  <p className="text-xs sm:text-sm text-white/60 font-light leading-relaxed">Sie füllen das Bewerbungsformular vollständig aus</p>
                </div>
                
                <div className="flex flex-col">
                  <div className="text-yellow-600 text-4xl sm:text-5xl font-light mb-2 sm:mb-3">02</div>
                  <h4 className="text-base sm:text-lg text-white font-light mb-2">Persönliches Gespräch</h4>
                  <p className="text-xs sm:text-sm text-white/60 font-light leading-relaxed">Wir lernen uns in einem kurzen Video-Call kennen</p>
                </div>
                
                <div className="flex flex-col">
                  <div className="text-yellow-600 text-4xl sm:text-5xl font-light mb-2 sm:mb-3">03</div>
                  <h4 className="text-base sm:text-lg text-white font-light mb-2">Entscheidung</h4>
                  <p className="text-xs sm:text-sm text-white/60 font-light leading-relaxed">Sie erhalten innerhalb von 7 Tagen eine Rückmeldung</p>
                </div>
              </div>

              {/* CTA */}
              <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-white/10">
                <a
                  href="#bewerbung"
                  className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-yellow-600 text-black rounded-full hover:bg-yellow-500 transition-colors group whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  <span className="font-light tracking-wide">Mitgliedschaft beantragen</span>
                  <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
